import React from 'react'

const TopBanner = () => {
  return (
      <div>
          <div class="position-relative overflow-hidden bugbounty min-vh-90   text-center bg-body-tertiary">

<div class="container-fluid   min-vh-80 d-flex justify-content-center align-items-center align-items-sm-center align-items-md-end align-items-lg-end">
    <div class="col-md-7 p-lg-5 h-auto mx-auto my-5 animate-fade ">

        <h2 class="display-4 fw-bold text-shadow text-light">Skills Uprise Hacking Lab</h2>
        <h4 class="fw-normal  mb-3 text-light text-shadow">Dominate Cybersecurity with 982 Cutting-Edge Virtual
            Hacking Labs !</h4>

        <div class="mt-4 justify-content-evenly mx-auto d-flex">
            <button class="btn btn-theme-success btn-lg px-4 rounded animate-fade ">Get started now</button>

        </div>


       

    </div>
</div>




</div>
      
    </div>
  )
}

export default TopBanner
